import { HelpCircle, X } from "lucide-react";
import { FC } from "react";
import { useClientTutorialStore } from "./client-tutorial.store";

export const ClientTutorialToggle: FC = () => {
  const { tutorialMode, toggleTutorialMode } = useClientTutorialStore();

  if (tutorialMode) {
    return (
      <div className="fixed bottom-0 left-0 right-0 bg-blue-600 text-white px-6 py-2 flex items-center justify-between z-50 shadow-lg">
        <div className="flex items-center gap-2 text-sm">
          <HelpCircle size={16} />
          <span className="font-medium">Tutorial Mode Active</span>
          <span className="text-blue-200">— Hover over elements to see descriptions</span>
        </div>
        <button
          onClick={toggleTutorialMode}
          className="flex items-center gap-1 px-3 py-1 rounded bg-blue-500 hover:bg-blue-400 text-sm"
        >
          <X size={14} />
          Exit
        </button>
      </div>
    );
  }

  return (
    <div className="flex justify-center py-4">
      <button
        onClick={toggleTutorialMode}
        className="flex items-center gap-2 px-4 py-2 text-sm text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg border border-transparent hover:border-blue-200 transition-colors"
      >
        <HelpCircle size={16} />
        Tutorial Mode
      </button>
    </div>
  );
};
